module.exports = __webpack_public_path__ + "img/AI_image.bb2463f9.png";